import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {DialogData} from 'src/app/services/dialog.service';

@Component({
  selector: 'app-alert-component',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
    if (!this.data.buttons) {
      this.data.buttons = [];
    }
  }
}
